export default class SinglePost {
    constructor() {

        this.section = document.querySelector('.page-single-post');
        this.linkCopy = document.querySelectorAll('[data-copyurl]')

        this.ready();
        
        if(window.innerWidth > 1024) {
            this.asideStick();
        }

    }

    ready() {

        this.section.querySelectorAll('.h3-link').forEach(link => {
            link.addEventListener('click', function(e) {
                // Remove a classe 'active' de todos os links
                document.querySelectorAll('.h3-link').forEach(link => {
                    link.classList.remove('active');
                });
        
                // Adiciona a classe 'active' ao link clicado
                this.classList.add('active');
            });
        });


        this.linkCopy.forEach((item) => {
            let url = item.dataset.copyurl
            let label = item.querySelector('.copy-label')
            
            item.addEventListener('click', () => {
                navigator.clipboard.writeText(url);
                label.classList.add('active')
                
                setTimeout(() => {
                    label.classList.remove('active')                    
                }, 2500);
            })
        })

    }

    asideStick() {
        window.addEventListener('scroll', function() {
            const aside = document.querySelector('aside'); // Selecione seu aside
            const content = document.querySelector('.singleContent'); // Selecione o conteúdo
            const asideHeight = aside.offsetHeight; // Altura do aside
            const contentHeight = content.offsetHeight; // Altura do conteúdo
            const contentTop = content.getBoundingClientRect().top + window.scrollY; // Posição inicial do conteúdo
            const scrollTop = window.scrollY; // Distância rolada da página
            const viewportHeight = window.innerHeight; // Altura da janela do navegador
        
            // Verifica se já passou do topo do aside e se ainda não passou do final do conteúdo
            if (scrollTop > contentTop && scrollTop < (contentTop + contentHeight - asideHeight)) {
                // Se ainda estiver no conteúdo, fixa o aside
                aside.style.position = 'fixed';
                aside.style.top = '144px'; // Distância desejada do topo
            } else if (scrollTop >= (contentTop + contentHeight - asideHeight)) {
                // Se chegou ao final do conteúdo, "descola" o aside
                aside.style.position = 'absolute';
                aside.style.top = (contentHeight - asideHeight) + 'px'; // Fixa na parte inferior do conteúdo
            } else {
                // Se estiver antes de começar o conteúdo, aside rola normalmente
                aside.style.position = 'relative';
                aside.style.top = 'auto';
            }
        });
    }

}

if (document.querySelector('.page-single-post')) {
    new SinglePost();
}